import { useState } from 'react';
import AudioPlayer from "../AudioPlayer.jsx";
import QuestionToolbar from "./QuestionToolbar.jsx";
import QuestionOption from "./QuestionOption.jsx";
import QuestionFreeTextOption from "./QuestionFreeTextOption.jsx";
import InputContainer from '../../InputContainer.jsx';
import ImageSelector from '../ImageSelector.jsx';
import { IMAGE_SELECTOR_IN_QUIZ_QUESTION, LOCK_ASPECT_QUESTION } from "../../Const.js";

import { Box, Typography, Paper } from '@mui/material';
import AIQuestionMetaGrid from './AIQuestionMetaGrid.jsx';


export default function MCQuestion({ loading, data, index, onQVariableSelect, onDuplicate, onUpDown, onAdd, onRemove, onEdit, onUndo, selectedMode, onTextChange }) {

    const [answerHidden, setAnswerHidden] = useState(true);
    const [editMode, setEditMode] = useState(false);

    const questionData = data.question;
    const criteriaData = data.criteria;
    const questionImage = questionData.imd;

    const onAudioTextChange = (value) => {

        let audioText = questionText.substring(0, questionText.lastIndexOf("^^") + 2);
        value = audioText + value;

        onTextChange(value);
    }


    const isContextImageQVariableAvailable = () => {

        let contextQVariable = criteriaData.questionParams.contextQVariable;
        return contextQVariable && contextQVariable.imageQVariable;
    }

    const isAudioQuestion = (questionText) => {
        return questionText && questionText.startsWith('^^');
    }

    const handleEditClicked = () => {
        onEdit(!editMode);
        setEditMode(!editMode);

    };

    const handleImageSelected = (imd) => {


        let imageOrigin;

        // image coming from context gallery
        if (contextImageMode) {
            imageOrigin = "CONTEXT_IMAGE";

            // image coming from image search
        } else {
            imageOrigin = "SEARCH_IMAGE";
        }


        onQVariableSelect(imd, null, imageOrigin);
    }


    const handleAltChange = (value) => {

        let questionImageClone = JSON.parse(JSON.stringify(questionImage));
        questionImageClone.alt = value;
        handleImageSelected(questionImageClone);
    }

    const contextImageMode = isContextImageQVariableAvailable();

    var correctUUID = questionData.correctOption.uuid;

    let freeTextMode = questionData.templateId.startsWith('GeneralMCQuestion');

    var answerList = questionData.displayedOptionList.map(function (a) {

        var answerUUID = a.uuid;

        return (!freeTextMode ?

            <QuestionOption key={a.uuid} type={answerUUID === correctUUID ? "CORRECT_OPTION" : "DISTRACTOR"} option={a} optionList={questionData.displayedOptionList} criteriaData={criteriaData} answerHidden={answerHidden} editMode={editMode} onQVariableSelect={onQVariableSelect}></QuestionOption>
            :
            <QuestionFreeTextOption key={a.uuid} type={answerUUID === correctUUID ? "CORRECT_OPTION" : "DISTRACTOR"} option={a} optionList={questionData.displayedOptionList} answerHidden={answerHidden} editMode={editMode} onQVariableSelect={onQVariableSelect} />

        )

    });


    function genrateSearchStr() {
        let searchStr;

        if (isContextImageQVariableAvailable()) {
            searchStr = criteriaData.questionParams.contextQVariable.quizzlerObject.label;

        } else {
            let qe = criteriaData.questionParams.quizzlerEntity;

            if (qe) {
                searchStr = criteriaData.questionParams.quizzlerEntity.label;
            }

        }

        searchStr = '"' + searchStr + '"';

        return searchStr;
    }


    const searchStr = genrateSearchStr();
    var questionText = questionData.textMessage;

    var questionHTML;
    if (isAudioQuestion(questionText)) {

        var audioUrl = questionText.substring(2, questionText.lastIndexOf('^^'));
        var audioText = questionText.substring(questionText.lastIndexOf('^^') + 2);
        questionHTML =
            <Box sx={{ marginBottom: '20px', marginTop: '10px' }}>
                {editMode && <InputContainer key={audioText} label='Question Text' value={audioText} onBlur={onAudioTextChange} />}
                {!editMode && <Typography variant='h6'>{audioText}</Typography>}
                <AudioPlayer audioUrl={audioUrl}></AudioPlayer>
            </Box>;

    } else {


        questionHTML =
            <Box sx={{ marginBottom: '20px', marginTop: '10px' }}>

                <Box sx={{ marginTop: '20px' }}>

                    <ImageSelector layout={IMAGE_SELECTOR_IN_QUIZ_QUESTION} imd={questionImage} lockAspect={LOCK_ASPECT_QUESTION} onAltChange={handleAltChange} onSelect={handleImageSelected} searchStr={searchStr}></ImageSelector>

                </Box>
                <Box sx={{ marginTop: '20px' }}>
                    {editMode && <InputContainer key={questionText} label='Question Text' value={questionText} onBlur={onTextChange} />}
                    {!editMode && <Typography variant='h6'>{questionText}</Typography>}
                </Box>
            </Box >;
    }

    var answerTextMessage = questionData.answerTextMessage
    var answerTextHtml = <Box className='answerTextMessage'>{answerTextMessage}</Box>;


    const handleShowHideAnswer = () => {

        setAnswerHidden(!answerHidden);

    }

    return (
        <Box>
            <Paper elevation={3} sx={{ pl: '30px', pr: '30px', pt: '10px', pb: '30px', backgroundColor: 'inherit' }} className={`${loading ? 'shimmer' : ''}`} key={questionData.templateId}>
                <Box className="questionHeaderContainer">

                    <QuestionToolbar freeTextMode={freeTextMode} index={index} data={criteriaData} onUndo={onUndo} onDuplicate={onDuplicate} onAdd={onAdd} onRemove={onRemove} selectedMode={selectedMode} editMode={editMode} onEdit={handleEditClicked} onQVariableSelect={onQVariableSelect} onUpDown={onUpDown} onShowHideAnswer={handleShowHideAnswer} answerHidden={answerHidden} />
                    <AIQuestionMetaGrid questionData={questionData} />
                </Box>

                <Box>{questionHTML}</Box>

                {answerList}

                <Typography variant="caption" >{answerTextMessage && !answerHidden ? answerTextHtml : null}</Typography>


            </Paper>
        </Box >

    )
};